import type React from 'react';

export interface BulbIconProps {
	width?: string | number;
	height?: string | number;
	fill?: string;
	stroke?: string;
	'aria-label'?: string;
}

const BulbIcon: React.FC<BulbIconProps> = ({
	width = 11,
	height = 18,
	fill = 'none',
	stroke = 'black',
	'aria-label': ariaLabel = 'Bulb Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 11 18"
		fill={fill}
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
	>
		<title>Bulb Icon</title>
		<path
			d="M5.7441 17.4993C7.11659 17.4993 7.90063 16.8549 8.08644 16.02H3.40234C3.58816 16.8549 4.37162 17.4993 5.7441 17.4993Z"
			fill="#D0CFCE"
		/>
		<path
			d="M8.47145 1.99244C8.47145 1.99244 4.9591 0.999617 3.24456 2.35688C1.53003 3.71415 1.40625 6.83707 1.40625 6.83707C1.57426 7.47263 2.61992 9.27619 2.61992 9.27619C2.775 9.53782 3.26696 11.4247 3.55301 12.5387H8.1251C8.3738 11.7216 9.37438 8.76212 9.50505 8.45769C9.67277 8.06625 9.95881 7.30433 10.1033 7.01685C10.4508 6.32501 10.4381 5.71501 10.2578 4.99876C9.86777 3.45223 9.54727 3.06797 8.47116 1.99186L8.47145 1.99244Z"
			fill="#FCEA2B"
		/>
		<path
			d="M5.7439 1.00086C3.29358 1.00086 1.00524 2.93998 1.00524 5.38915C1.00524 5.69903 0.929419 6.67893 1.35475 6.67893C1.35475 6.67893 2.042 4.43165 3.75624 3.07467C5.47049 1.71769 8.21346 2.00488 8.21346 2.00488C8.02276 1.41758 6.61954 1 5.74476 1L5.7439 1.00086Z"
			fill="white"
		/>
		<path
			d="M5.82724 12.4937V9.06464M7.54177 9.06464H4.11271M10.5803 5.75332C10.5803 6.89778 10.0676 7.45005 9.50214 8.76884C9.35768 9.10542 8.29278 12.6115 8.29278 12.6115H3.3617C3.3617 12.6115 2.50558 9.25993 2.34332 8.9871C1.66267 7.83891 1.07422 7.00261 1.07422 5.75332C1.07422 3.12811 3.20231 1.00031 5.82724 1.00031C8.45217 1.00031 10.5803 3.12839 10.5803 5.75332Z"
			stroke={stroke}
			strokeWidth="0.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8.16847 15.8163C8.16847 16.7468 7.11993 17.5013 5.82642 17.5013C4.53291 17.5013 3.48438 16.7468 3.48438 15.8163H8.16847Z"
			stroke={stroke}
			strokeWidth="0.424"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M3.52734 14.7223L8.12815 13.7257"
			stroke={stroke}
			strokeWidth="0.49125"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M6.45877 15.0355L8.11873 14.6966M3.53516 13.7518L5.19512 13.4129"
			stroke={stroke}
			strokeWidth="0.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default BulbIcon;
